import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DevUIModule } from 'ng-devui';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DialogFormJs604FillComponent } from './biz-zj-zp/dialog-form-js604-fill/dialog-form-js604-fill.component';
import { DialogFormZjConfigComponent } from './biz-zj-zp/dialog-form-zj-config/dialog-form-zj-config.component';
import { DialogFormZjFillComponent } from './biz-zj-zp/dialog-form-zj-fill/dialog-form-zj-fill.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CustomSignComponent } from './components/custom-sign/custom-sign.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { DetectionDesignComponent } from './components/detection-design/detection-design.component';
import { DetectionRealComponent } from './components/detection-real/detection-real.component';
import { DialogWbsChooseComponent } from './components/dialog-wbs-choose/dialog-wbs-choose.component';
import { FilePreviewEntryComponent } from './components/file-preview-entry/file-preview-entry.component';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { FlowPositionCascaderComponent } from './components/flow-position-cascader/flow-position-cascader.component';
import { FormPreviewComponent } from './components/form-preview/form-preview.component';
import { FormatDataComponent } from './components/format-data/format-data.component';
import { GridProComponent } from './components/grid-pro/grid-pro.component';
import { LocationCascaderComponent } from './components/location-cascader/location-cascader.component';
import { MeasuredDisplayComponent } from './components/measured-display/measured-display.component';
import { ProcedureFileComponent } from './components/procedure-file/procedure-file.component';
import { SpreadsheetFormComponent } from './components/spreadsheet-form/spreadsheet-form.component';
import { SpreadsheetLiteComponent } from './components/spreadsheet-lite/spreadsheet-lite.component';
import { TableProComponent } from './components/table-pro/table-pro.component';
import { UserSelectPopoverComponent } from './components/user-select-popover/user-select-popover.component';
import { WbsCascaderComponent } from './components/wbs-cascader/wbs-cascader.component';
import { WbsJgCascaderComponent } from './components/wbs-jg-cascader/wbs-jg-cascader.component';
import { WbsUnitCascaderComponent } from './components/wbs-unit-cascader/wbs-unit-cascader.component';
import { AmountFormatDirective } from './directives/amount-format.directive';
import { DetectionBiasValDirective } from './directives/detection-bias-val.directive';
import { DetectionDesignValDirective } from './directives/detection-design-val.directive';
import { DetectionPassValDirective } from './directives/detection-pass-val.directive';
import { DetectionRealValDirective } from './directives/detection-real-val.directive';
import { DigitalFormatDirective } from './directives/digital-format.directive';
import { FloatFormatDirective } from './directives/float-format.directive';
import { FormulaFormatDirective } from './directives/formula-format.directive';
import { HostDirective } from './directives/host.directive';
import { MouseLeaveDirective } from './directives/mouse-leave.directive';
import { NumberFormatDirective } from './directives/number-format.directive';
import { SafeHtmlPipe } from './directives/safe-html.pipe';
import { SafeResourceUrlPipe } from './directives/safe-resource-url.pipe';
import { CopyReportFilterPipe } from './pipes/copy-report-filter.pipe';
import { CounterSignFilterPipe } from './pipes/counter-sign-filter.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { FormCopyFilterPipe } from './pipes/form-copy-filter.pipe';
import { HistoryFilterPipe } from './pipes/history-filter.pipe';
import { OrgTypeFilterPipe } from './pipes/org-type-filter.pipe';
import { PrccFilterPipe } from './pipes/prcc-filter.pipe';
import { ProjectTypeExtFilterPipe } from './pipes/project-type-ext-filter.pipe';
import { TableItemFilterPipe } from './pipes/table-item-filter.pipe';
import { AuthGuard } from './providers/auth.guard';
import { BreadcrumbService } from './providers/breadcrumb.service';
import { EventService } from './providers/event.service';
import { GlobalService } from './providers/global.service';
import { LocalStorageService } from './providers/local-storage.service';
import { RequestInterceptor } from './providers/request/request.interceptor';
import { SocketHandler } from './providers/socket-handler.service';
import { AppVersionService } from './services/app-version.service';
import { ArchiveCatalogNameRuleService } from './services/archive-catalog-name-rule.service';
import { ArchiveCatalogVolumeCodeRuleService } from './services/archive-catalog-volume-code-rule.service';
import { ArchiveCatalogService } from './services/archive-catalog.service';
import { ArchiveFileAttachService } from './services/archive-file-attach.service';
import { ArchiveFileFormHeaderService } from './services/archive-file-form-header.service';
import { ArchiveFileGroupService } from './services/archive-file-group.service';
import { ArchiveFileSyncRuleService } from './services/archive-file-sync-rule.service';
import { ArchiveFileTitleRuleService } from './services/archive-file-title-rule.service';
import { ArchiveFileService } from './services/archive-file.service';
import { ArchiveVolumeFileService } from './services/archive-volume-file.service';
import { ArchiveVolumeRuleService } from './services/archive-volume-rule.service';
import { ArchiveVolumeService } from './services/archive-volume.service';
import { CommonService } from './services/common.service';
import { DeviceTypeService } from './services/device-type.service';
import { DeviceService } from './services/device.service';
import { FormOverdueReplyConfigService } from './services/form-overdue-reply-config.service';
import { FormOverdueSignConfigService } from './services/form-overdue-sign-config.service';
import { InspectionJgItemFileService } from './services/inspection-jg-item-file.service';
import { InspectionJgItemService } from './services/inspection-jg-item.service';
import { InspectionMaterialService } from './services/inspection-material.service';
import { InspectionMonthlyService } from './services/inspection-monthly.service';
import { InspectionProjectService } from './services/inspection-project.service';
import { InspectionQaCertificateService } from './services/inspection-qa-certificate.service';
import { InspectionQualityRegulationService } from './services/inspection-quality-regulation.service';
import { InspectionQuarterlyService } from './services/inspection-quarterly.service';
import { InspectionUniqualifiedService } from './services/inspection-uniqualified.service';
import { InspectionUnknownpartService } from './services/inspection-unknownpart.service';
import { JgInspSolutionService } from './services/jg-insp-solution.service';
import { JgPhysicalInspCfgService } from './services/jg-physical-insp-cfg.service';
import { JgPhysicalInspReportFileService } from './services/jg-physical-insp-report-file.service';
import { JgPhysicalInspUnitDwService } from './services/jg-physical-insp-unit-dw.service';
import { JgPhysicalInspUnitFbService } from './services/jg-physical-insp-unit-fb.service';
import { JgPhysicalInspUnitFxItemFormService } from './services/jg-physical-insp-unit-fx-item-form.service';
import { JgPhysicalInspUnitFxItemService } from './services/jg-physical-insp-unit-fx-item.service';
import { JgPhysicalInspUnitFxService } from './services/jg-physical-insp-unit-fx.service';
import { JgPhysicalInspUnitItemProgressService } from './services/jg-physical-insp-unit-item-progress.service';
import { JgPhysicalInspUnitService } from './services/jg-physical-insp-unit.service';
import { JgVisualInspCfgService } from './services/jg-visual-insp-cfg.service';
import { JgVisualInspReportFileService } from './services/jg-visual-insp-report-file.service';
import { JgVisualInspUnitFbDetailService } from './services/jg-visual-insp-unit-fb-detail.service';
import { JgVisualInspUnitFbService } from './services/jg-visual-insp-unit-fb.service';
import { LoginTypeConfigService } from './services/login-type-config.service';
import { MaterialBatchService } from './services/material-batch.service';
import { MaterialManufacturerService } from './services/material-manufacturer.service';
import { MaterialModelService } from './services/material-model.service';
import { MaterialTypeService } from './services/material-type.service';
import { MaterialWhService } from './services/material-wh.service';
import { OmDepartmentService } from './services/om-department.service';
import { OmFormCodeSnService } from './services/om-form-code-sn.service';
import { OmFormCodeService } from './services/om-form-code.service';
import { OmFormEntryService } from './services/om-form-entry.service';
import { OmFormHeaderService } from './services/om-form-header.service';
import { OmFormItemAttachmentService } from './services/om-form-item-attachment.service';
import { OmFormItemFlowService } from './services/om-form-item-flow.service';
import { OmFormItemMeasuredProjectService } from './services/om-form-item-measured-project.service';
import { OmFormItemService } from './services/om-form-item.service';
import { OmFormParamService } from './services/om-form-param.service';
import { OmFormService } from './services/om-form.service';
import { OmIotDeviceDataService } from './services/om-iot-device-data.service';
import { OmIotDeviceTypeService } from './services/om-iot-device-type.service';
import { OmIotDeviceService } from './services/om-iot-device.service';
import { JobConfigService } from './services/om-job-config.service';
import { JobLogService } from './services/om-job-log.service';
import { OmLaboratoryService } from './services/om-laboratory.service';
import { OmMenuAuditService } from './services/om-menu-audit.service';
import { OmMenuFormService } from './services/om-menu-form.service';
import { OmMenuService } from './services/om-menu.service';
import { OmOpenAppCallBackConfigService } from './services/om-open-app-callback-config.service';
import { OmOpenAppConfigService } from './services/om-open-app-config.service';
import { OmOpenAppLogService } from './services/om-open-app-log.service';
import { OmOpenAppSignOrderService } from './services/om-open-app-sign-order.service';
import { OmOpenAppService } from './services/om-open-app.service';
import { OmPostService } from './services/om-post.service';
import { OmUserOrgSealDataService } from './services/om-user-org-sealdata.service';
import { OmUserOrgService } from './services/om-user-org.service';
import { OmUserPersonSealDataService } from './services/om-user-person-sealdata.service';
import { OmUserPersonService } from './services/om-user-person.service';
import { OpenApiSignOrderService } from './services/open-api-signorder.service';
import { OpenMessageUpdateLogService } from './services/open-message-update-log.service';
import { OpenMessageUserService } from './services/open-message-user.service';
import { OpenMessageService } from './services/open-message.service';
import { ProjectContractService } from './services/project-contract.service';
import { ProjectFormService } from './services/project-form.service';
import { ProjectPlanService } from './services/project-plan.service';
import { ProjectProgressService } from './services/project-progress.service';
import { ProjectRuleRegulationService } from './services/project-rule-regulation.service';
import { ProjectSectionItemService } from './services/project-section-item.service';
import { ProjectSectionUnitFormFileService } from './services/project-section-unit-form-file.service';
import { ProjectSectionUnitFormService } from './services/project-section-unit-form.service';
import { ProjectSectionService } from './services/project-section.service';
import { ProjectSubformService } from './services/project-sub-form.service';
import { ProjectTypeExtService } from './services/project-type-ext.service';
import { ProjectTypeService } from './services/project-type.service';
import { ProjectWbsService } from './services/project-wbs.service';
import { ProjectService } from './services/project.service';
import { StaffDepartmentService } from './services/staff-department.service';
import { StaffOrganizationMemberService } from './services/staff-organization-member.service';
import { StaffOrganizationService } from './services/staff-organization.service';
import { StaffPostService } from './services/staff-post.service';
import { StaffUserService } from './services/staff-user.service';
import { WorkFlowTaskOverdueService } from './services/work-flow-task-overdue.service';
import { WorkFlowTaskService } from './services/work-flow-task.service';
import { WorkFlowUserService } from './services/work-flow-user.service';
import { WorkReportFormService } from './services/work-report-form.service';
import { WorkReportService } from './services/work-report.service';
import { CommonSmsLogService } from './services/common-sms-log.service';
import { ConfigConstantsService } from './services/config-constants.service';
@NgModule({
  declarations: [
    FormatDataComponent,
    SafeHtmlPipe,
    SafeResourceUrlPipe,
    TableProComponent,
    AlertDialogComponent,
    HostDirective,
    AmountFormatDirective,
    FloatFormatDirective,
    DigitalFormatDirective,
    FormulaFormatDirective,
    NumberFormatDirective,
    BreadcrumbComponent,
    LocationCascaderComponent,
    MouseLeaveDirective,
    DateRangeComponent,
    FilePreviewEntryComponent,
    FilePreviewComponent,
    SpreadsheetLiteComponent,
    SpreadsheetFormComponent,
    ProcedureFileComponent,
    FormPreviewComponent,
    WbsCascaderComponent,
    FlowPositionCascaderComponent,
    TableItemFilterPipe,
    OrgTypeFilterPipe,
    ProjectTypeExtFilterPipe,
    WbsUnitCascaderComponent,
    DialogWbsChooseComponent,
    GridProComponent,
    DetectionDesignValDirective,
    DetectionBiasValDirective,
    DetectionRealValDirective,
    DetectionPassValDirective,
    DetectionDesignComponent,
    DetectionRealComponent,
    CustomSignComponent,
    FormCopyFilterPipe,
    UserSelectPopoverComponent,
    HistoryFilterPipe,
    CounterSignFilterPipe,
    PrccFilterPipe,
    DialogFormZjConfigComponent,
    DialogFormZjFillComponent,
    MeasuredDisplayComponent,
    CopyReportFilterPipe,
    DialogFormJs604FillComponent,
    FileSizePipe,
    WbsJgCascaderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzCascaderModule,
    NzIconModule,
    NzPopoverModule,
    NzTimePickerModule,
    NzDatePickerModule,
    NzDropDownModule,
    NzMessageModule,
    NzPaginationModule,
    NzCheckboxModule,
    NzRadioModule,
    NzLayoutModule,
    NzSpinModule,
    NzToolTipModule,
    NzButtonModule,
    NzTabsModule,
    NzSelectModule,
    NzInputModule,
    NzModalModule,
    DevUIModule,
    PdfViewerModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    NzCascaderModule,
    NzPaginationModule,
    NzLayoutModule,
    NzSpinModule,
    NzToolTipModule,
    NzTabsModule,
    NzMenuModule,
    NzDropDownModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzPopoverModule,
    NzRadioModule,
    NzIconModule,
    NzButtonModule,
    NzSelectModule,
    NzInputModule,
    NzModalModule,
    PdfViewerModule,
    FormatDataComponent,
    FlowPositionCascaderComponent,
    SafeHtmlPipe,
    SafeResourceUrlPipe,
    FormCopyFilterPipe,
    HistoryFilterPipe,
    CounterSignFilterPipe,
    CopyReportFilterPipe,
    PrccFilterPipe,
    FileSizePipe,
    TableProComponent,
    AlertDialogComponent,
    HostDirective,
    AmountFormatDirective,
    FloatFormatDirective,
    DigitalFormatDirective,
    NumberFormatDirective,
    FormulaFormatDirective,
    DetectionDesignValDirective,
    DetectionBiasValDirective,
    DetectionRealValDirective,
    DetectionPassValDirective,
    DetectionDesignComponent,
    DetectionRealComponent,
    CustomSignComponent,
    TableItemFilterPipe,
    OrgTypeFilterPipe,
    ProjectTypeExtFilterPipe,
    BreadcrumbComponent,
    LocationCascaderComponent,
    MouseLeaveDirective,
    DateRangeComponent,
    FilePreviewEntryComponent,
    FilePreviewComponent,
    ProcedureFileComponent,
    GridProComponent,
    SpreadsheetLiteComponent,
    SpreadsheetFormComponent,
    FormPreviewComponent,
    WbsCascaderComponent,
    WbsUnitCascaderComponent,
    DialogWbsChooseComponent,
    UserSelectPopoverComponent,
    DevUIModule,
    WbsJgCascaderComponent,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        TableItemFilterPipe,
        OrgTypeFilterPipe,
        GlobalService,
        BreadcrumbService,
        LocalStorageService,
        EventService,
        AuthGuard,
        SocketHandler,
        // 接口服务
        AppVersionService,
        ArchiveCatalogNameRuleService,
        ArchiveCatalogVolumeCodeRuleService,
        ArchiveCatalogService,
        ArchiveFileAttachService,
        ArchiveFileFormHeaderService,
        ArchiveFileGroupService,
        ArchiveFileSyncRuleService,
        ArchiveFileTitleRuleService,
        ArchiveFileService,
        ArchiveVolumeFileService,
        ArchiveVolumeRuleService,
        ArchiveVolumeService,
        CommonService,
        CommonSmsLogService,
        ConfigConstantsService,
        DeviceTypeService,
        DeviceService,
        OmFormCodeService,
        InspectionJgItemService,
        InspectionJgItemFileService,
        InspectionMaterialService,
        InspectionMonthlyService,
        InspectionProjectService,
        InspectionQaCertificateService,
        InspectionQualityRegulationService,
        InspectionQuarterlyService,
        InspectionUniqualifiedService,
        InspectionUnknownpartService,
        MaterialBatchService,
        MaterialManufacturerService,
        MaterialModelService,
        MaterialTypeService,
        MaterialWhService,
        OmDepartmentService,
        OmFormEntryService,
        OmFormItemAttachmentService,
        OmFormItemMeasuredProjectService,
        OmFormItemFlowService,
        OmFormItemService,
        OmFormParamService,
        OmFormService,
        OmFormCodeService,
        OmFormHeaderService,
        OmFormCodeSnService,
        OmIotDeviceDataService,
        OmIotDeviceTypeService,
        OmIotDeviceService,
        OmLaboratoryService,
        OmMenuAuditService,
        OmMenuFormService,
        OmMenuService,
        OmPostService,
        ProjectTypeExtService,
        OmUserPersonSealDataService,
        OmUserPersonService,
        OmUserOrgSealDataService,
        OmUserOrgService,
        OpenApiSignOrderService,
        ProjectContractService,
        ProjectFormService,
        ProjectSubformService,
        ProjectPlanService,
        ProjectProgressService,
        ProjectRuleRegulationService,
        ProjectSectionItemService,
        ProjectSectionUnitFormService,
        ProjectSectionUnitFormFileService,
        ProjectSectionService,
        ProjectTypeService,
        ProjectWbsService,
        ProjectService,
        StaffDepartmentService,
        StaffOrganizationService,
        StaffOrganizationMemberService,
        StaffPostService,
        StaffUserService,
        WorkFlowTaskService,
        WorkFlowUserService,
        WorkReportFormService,
        WorkReportService,
        OmOpenAppService,
        OmOpenAppConfigService,
        OmOpenAppCallBackConfigService,
        OmOpenAppLogService,
        OmOpenAppSignOrderService,
        OpenMessageService,
        OpenMessageUserService,
        OpenMessageUpdateLogService,
        FormOverdueSignConfigService,
        FormOverdueReplyConfigService,
        WorkFlowTaskOverdueService,
        JobConfigService,
        JobLogService,
        LoginTypeConfigService,
        JgInspSolutionService,
        JgPhysicalInspReportFileService,
        JgPhysicalInspCfgService,
        JgPhysicalInspUnitDwService,
        JgPhysicalInspUnitFbService,
        JgPhysicalInspUnitFxItemFormService,
        JgPhysicalInspUnitFxItemService,
        JgPhysicalInspUnitFxService,
        JgPhysicalInspUnitItemProgressService,
        JgPhysicalInspUnitService,
        JgVisualInspCfgService,
        JgVisualInspReportFileService,
        JgVisualInspUnitFbDetailService,
        JgVisualInspUnitFbService,
        // 拦截器
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RequestInterceptor,
          multi: true,
        },
      ],
    };
  }
}
